export default class ScreenSizeManager {
    // singleton pattern

    #screenTypeConfig = {
        mobile: [0, 768],
        tablet: [768, 992],
        desktop: [992, null],
    };
    #viewPortWidth;
    #screenType;

    constructor() {
        if (ScreenSizeManager.singleton) {
            return ScreenSizeManager.singleton;
        }

        ScreenSizeManager.singleton = this;
        return ScreenSizeManager.singleton;
    }

    get screenType() {
        return this.#screenType;
    }

    #getViewportWidth() {
        return Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    }
    #getViewportHeight() {
        return Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
    }
    #checkWidthForScreenType(type) {
        const [lower, upper] = this.#screenTypeConfig[type];
        if (lower && this.#viewPortWidth < lower) {
            return false;
        }
        if (upper && this.#viewPortWidth >= upper) {
            return false;
        }
        return true;
    }
    #isMobile() {
        return this.#checkWidthForScreenType("mobile");
    }
    #isTablet() {
        return this.#checkWidthForScreenType("tablet");
    }
    #isDesktop() {
        return this.#checkWidthForScreenType("desktop");
    }

    #getScreenType() {
        if (this.#isMobile()) return "mobile";
        if (this.#isDesktop()) return "desktop";
        if (this.#isTablet()) return "tablet";
    }

    #updateData() {
        const currentScreenType = this.#screenType;
        this.#viewPortWidth = this.#getViewportWidth();
        const newScreenType = this.#getScreenType();
        this.#screenType = newScreenType;
        if (currentScreenType !== newScreenType) {
            window.dispatchEvent(new CustomEvent("screenTypeChange", { detail: { newType: this.#screenType } }));
        }
    }

    #setListeners() {
        const resizeListener = () => {
            window.removeEventListener("resize", resizeListener);

            this.#updateData();

            setTimeout(() => {
                window.addEventListener("resize", resizeListener, { passive: true });
            }, 50);
        };
        window.addEventListener("resize", resizeListener);
    }

    init() {
        this.#updateData();
        this.#setListeners();
    }
}
